import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HomeStatsComponent } from '../home-stats/home-stats.component';

@Component({
  selector: 'app-slider-home',
  imports: [CommonModule, TranslateModule, HomeStatsComponent],
  standalone: true,
  templateUrl: './slider-home.component.html',
  styleUrl: './slider-home.component.scss'
})
export class SliderHomeComponent implements OnInit, OnDestroy {
  actualSlider = 0;
  slides = this.buildSlides('cs');

  private langSub?: Subscription;
  private autoplayId: ReturnType<typeof setInterval> | null = null;
  private readonly autoplayMs = 4000;
  private readonly isBrowser: boolean;

  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.updateSlidesForLang(this.translate.currentLang || 'cs');
    this.langSub = this.translate.onLangChange.subscribe(e => {
      this.updateSlidesForLang(e.lang);
    });
    this.startAutoplay();
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
    this.stopAutoplay();
  }

  goToSlide(index: number): void {
    if (index < 0 || index >= this.slides.length) return;
    this.actualSlider = index;
    this.restartAutoplay();
  }

  private buildSlides(lang: string): { img: string }[] {
    const useCzech = lang === 'cs' || lang === 'sk';
    return [
      {
        img: useCzech
          ? '/assets/img/design-2026/carousel-AC-czech.png'
          : '/assets/img/design-2026/carousel-AC-english.png',
      },
      {
        img: useCzech
          ? '/assets/img/design-2026/carousel-GP-czech.png'
          : '/assets/img/design-2026/carousel-GP-english.png',
      },
    ];
  }

  private updateSlidesForLang(lang: string): void {
    this.slides = this.buildSlides(lang);
    if (this.actualSlider >= this.slides.length) {
      this.actualSlider = 0;
    }
  }

  private startAutoplay(): void {
    if (!this.isBrowser || this.autoplayId != null) return;
    this.autoplayId = setInterval(() => {
      this.actualSlider = (this.actualSlider + 1) % this.slides.length;
    }, this.autoplayMs);
  }

  private stopAutoplay(): void {
    if (this.autoplayId != null) {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    }
  }

  private restartAutoplay(): void {
    this.stopAutoplay();
    this.startAutoplay();
  }
}
